import React from 'react';
import { useUser } from '@lore/auth';
import { useConnect } from '@lore/query-connect';
import ParentLayout from '../Layout';
import Navigation from '../../../dialogs_common/Navigation';
import Urls from '../Urls';
import Form from './Form';
import { PayloadStates } from '@lore/utils';
import useRouter from '../../../hooks/useRouter';

export default function Layout(props) {
  const { location, history, match } = useRouter();
  const user = useUser();
  const project = useConnect('project.byId', {
    id: Number(match.params.projectId)
  });

  if (project.state === PayloadStates.FETCHING) {
    return null;
  }

  return (
    <ParentLayout
      project={project}
      page="Date"
      title="When do you want your project to happen?"
    >
      <Form
        user={user}
        project={project}
        navigation={(
          <Navigation v5={true} activeStep={11} steps={19}/>
        )}
        onPrevious={(newData) => history.push(Urls(project).PARTNER)}
        onNext={(newData) => history.push(Urls(project).DAYS)}
        onSkip={() => history.push(Urls(project).DAYS)}
        onExit={() => history.push(Urls(project).PROJECT_EDIT)}
      />
    </ParentLayout>
  );
};
